import React from "react";

import { useTranslation } from "react-i18next";

import { BookingTemplateFormTypes } from "@assets/formTypes";

type TransportRequestCarouselInfoProps = {
  content: BookingTemplateFormTypes.TransportRequestForm;
};

const TransportRequestCarouselInfo = ({
  content,
}: TransportRequestCarouselInfoProps) => {
  const { t } = useTranslation();
  return (
    <span>
      <p className="font-bold text-neutral-900">{content.CompanyName}</p>
      <p className="text-neutral-900">{content.StreetAndNumber}</p>
      <p className="text-neutral-900">
        {content.PostalCode} {content.City}
      </p>
      <p className="text-neutral-900">{content.Country}</p>
      <br />
      <p>
        <span>{`${t("LABEL_CONTACT_PERSON")}: `}</span>
        <span className="text-neutral-900">
          {content.ContactName || t("TEXT_NOT_PROVIDED")}
        </span>
      </p>
      <p>
        <span>{`${t("LABEL_EMAIL")}: `}</span>
        <span className="text-neutral-900">
          {content.Email || t("TEXT_NOT_PROVIDED")}
        </span>
      </p>
      <p>
        <span>{`${t("LABEL_PHONE")}: `}</span>
        <span className="text-neutral-900">
          {content.Phone || t("TEXT_NOT_PROVIDED")}
        </span>
      </p>
      <p>
        <span>{`${t("LABEL_ADDITIONAL_INFO")}: `}</span>
        <span className="text-neutral-900">
          {content.AdditionalAddressInfo || t("TEXT_NOT_PROVIDED")}
        </span>
      </p>
    </span>
  );
};

export default TransportRequestCarouselInfo;
